// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * EmailSendService is the service for sending emails.
 * For more information on email at Weave, see:
 *  https://weave.knowledge.seismic.com/content/8e867580-2bea-4e56-ba48-b7f6a6037107
 */
export const EmailSendService = {
    /**
     * Send is the standard email send method.
     * Use this to send emails from a location to a customer/patient of
     * that location.
     */
    Send(fn, req) {
        return fn(`/email/send/v2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * WeaveSend is a special email send method for sending emails
     * that are "from" Weave, rather than from a customer's location.
     * Examples of such messages are onboarding emails, Weave
     * password reset emails, and various internal emails.
     */
    WeaveSend(fn, req) {
        return fn(`/email/send/v2/weave`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * WeaveUpdateSend is a special email send method for sending emails
     * that are "from" Weave, but associated with a specific customer location,
     * and which provide updates on how that location is using Weave.
     * Examples of such messages are weekly auto-messaging outcome reports,
     * daily call intelligence reports, and every-time messages about payment
     * transactions.
     */
    WeaveUpdateSend(fn, req) {
        return fn(`/email/send/v2/weave-update`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
